import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { LoadingOverlay, useAuth } from '@spotify/confidence-core-react';
import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

const LoginPageComponent = () => {
  const [searchParams] = useSearchParams();
  const { loginWithRedirect } = useAuth();
  const organization = searchParams.get('organization');

  useEffect(() => {
    loginWithRedirect({
      authorizationParams: {
        organization: organization || undefined,
      },
    });
  }, [organization, loginWithRedirect]);

  return <LoadingOverlay loading />;
};

export const LoginPage = withPageImpression(LoginPageComponent, {
  pageId: 'login',
});
